import { Instance, types } from 'mobx-state-tree';

import { getProgramsList } from '@common/api/curators';
import ChatProgram from '@common/models/ChatPrograms/ChatProgram';
import TableData from '@common/models/TableData';

const ChatPrograms = types
	.compose(
		TableData,
		types.model({
			data: types.optional(types.array(ChatProgram), []),
			service_id: types.maybe(types.number),
		}),
	)
	.named('ChatPrograms')
	.actions((self) => ({
		_fetch: (query: any) => getProgramsList({ service_id: self.service_id, ...query }),
	}));

export default ChatPrograms;

export interface IChatProgramsModel extends Instance<typeof ChatPrograms> {}
